import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ProposalProjectObjective } from "../Model/ProposalProjectObjective";

export async function deleteProposalObjective(idProposalProject, idObj) {
    let response = await getAPIResponse("/v1/proposal-project-objective/"+idProposalProject+'/'+idObj, {} , "DELETE");
    if (response === null) {
        return null;
    }
    let proposalProjectObjective = ProposalProjectObjective.createFromResponseData(response);
    return proposalProjectObjective;
}